// An open cardboard box folds its flaps shut, is taped, and stays closed for a minute.
const LEAD = 0.6, HOLD = 60, END = 2.2 + HOLD, CYCLE = LEAD + END + 1.1
const OPEN = 118

const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x))
const ease = t => t * t * (3 - 2 * t)

function build(el) {
  const part = name => el.querySelector(`.${name}`)

  return {scene: part('scene'), left: part('flap-left'), right: part('flap-right'), tape: part('tape')}
}

function draw({scene, left, right, tape}, t) {
  const first = ease(clamp((t - 0.4) / 0.8)), second = ease(clamp((t - 0.9) / 0.8))

  scene.setAttribute('opacity', (1 - clamp((t - END) / 0.6)).toFixed(3))
  left.setAttribute('transform', `rotate(${(-OPEN * (1 - first)).toFixed(1)} 80 60)`)
  right.setAttribute('transform', `rotate(${(OPEN * (1 - second)).toFixed(1)} 160 60)`)
  tape.setAttribute('opacity', clamp((t - 1.8) / 0.3).toFixed(3))
}

let Hooks = {}

Hooks['Animations.DeviceShipped'] = {
  mounted() {
    const scene = build(this.el)

    // Closed and taped, held still.
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return draw(scene, 3)

    const start = performance.now()
    const frame = now => {
      draw(scene, ((now - start) / 1000) % CYCLE - LEAD)
      this.raf = requestAnimationFrame(frame)
    }
    this.raf = requestAnimationFrame(frame)
  },

  destroyed() {
    cancelAnimationFrame(this.raf)
  }
}

export {Hooks}
